import { ReactElement } from 'react';
import { useRouter } from 'next/router';
import { Trans, useTranslation } from 'next-i18next';
import get from 'lodash/get';

import { LanguageCode } from '@Hotels-at-Home/hah-fe-core/dist/constants';
import Article from '~/ui/components/layouts/Article';
import { getRoutePostLink, generateLinkComponents } from '~/utils/blog';
import { postData } from '~/constants/blog';

const Post1 = (): ReactElement => {
  const { t: tArticle } = useTranslation('', { keyPrefix: '$local.$articles.$article1' });
  const { t: tNext } = useTranslation('', { keyPrefix: '$local.$articles.$article2' });

  const router = useRouter();
  const locale = router.locale as LanguageCode;

  const currentPostId = 1;
  const lastPostId = 2;

  let lastPostUrl = get(postData, [lastPostId, 'urls', locale]);
  lastPostUrl = getRoutePostLink(lastPostUrl, locale);

  const articleData = {
    id: currentPostId,
    hero: {
      heading: tArticle('title'),
      text: tArticle('subTitle'),
    },
    last: {
      url: lastPostUrl,
      id: lastPostId,
      heading: tNext('title'),
      text: tNext('subTitleCopy'),
      cta: tArticle('nextCta'),
    },
  };

  return (
    <Article id={articleData.id} hero={articleData.hero} last={articleData.last}>
      <h2>{tArticle('paragraphTitle1')}</h2>
      <p>
        <Trans
          i18nKey="paragraphText1"
          t={tArticle}
          components={{
            br: <br />,
            strong: <strong />,
          }}
        />
      </p>
      <h2>{tArticle('paragraphTitle2')}</h2>
      <p>
        <Trans
          i18nKey="paragraphText2"
          t={tArticle}
          components={{
            br: <br />,
            strong: <strong />,
            ...generateLinkComponents(tArticle, 1, 6),
          }}
        />
      </p>
      <h2>{tArticle('paragraphTitle3')}</h2>
      <p>
        <Trans
          i18nKey="paragraphText3"
          t={tArticle}
          components={{
            br: <br />,
            strong: <strong />,
            ...generateLinkComponents(tArticle, 7, 17),
          }}
        />
      </p>
      <p className="closing">
        <Trans
          i18nKey="paragraphText4"
          t={tArticle}
          components={{
            br: <br />,
            strong: <strong />,
          }}
        />
      </p>
    </Article>
  );
};

export default Post1;
